import React, { PropTypes, Component } from 'react';
import { DropTarget } from 'react-dnd';
import { compose } from 'ramda';

const boxTarget = {
  drop(props) {
    return { position: props.position };
  },
};

const dragSourceFn = DropTarget('DRAG_SOURCE', boxTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
}));
const Target = props => {
  const {
    canDrop,
    isOver,
    connectDropTarget,
    inactiveStyle,
    inactiveClassName,
    activeStyle,
    activeClassName,
    canDropStyle,
    canDropClassName,
  } = props;
  const isActive = canDrop && isOver;
  const { style, className } = (() => {
    if (isActive) return { style: activeStyle, className: activeClassName };
    if (canDrop) return { style: canDropStyle, className: canDropClassName };
    return { style: inactiveStyle, className: inactiveClassName };
  })();
  return connectDropTarget(
    <div style={style} className={className}>
      {isActive ?
        'Release to drop' :
        'Drop here'
      }
    </div>,
  );
};

Target.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired,
  canDrop: PropTypes.bool.isRequired,
  inactiveStyle: PropTypes.object,
  inactiveClassName: PropTypes.string,
  position: PropTypes.any,
  activeStyle: PropTypes.object,
  activeClassName: PropTypes.string,
  canDropStyle: PropTypes.object,
  canDropClassName: PropTypes.string,
};

export default compose(dragSourceFn)(Target);



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/dnd/drop-target.jsx